import { createFeature } from '@ngrx/store';
import { flowStatusReducer } from './flow-status-reducer';

export const flowStatusFeature = createFeature(
  {
    name: 'FlowStatus',
    reducer: flowStatusReducer,
  },
);
